// Stub: cart / inbox / notifications / avatar (or Log in / Sign up) for the redesigned navigation.
// Implemented in a later phase.
function UserActions() {
  return null
}

export default UserActions
